export default {
  namespaced: true,
  video_tour: {
    name: "Nome",
    time_interval: "Intervalo de tempo",
    time_interval_description: "Intervalo de tempo em segundos",
    preview: "Visualização prévia.",
    preview_message: "Clique em um item para ver uma pré-visualização.",
    success: "Vídeo tour salvo com sucesso",
    views_list: "Lista de visualizações",
    selected_views: "Visualizações selecionadas",
    items_selected: "Itens selecionados",
    confirm_delete: "Tem certeza de que deseja excluir o vídeo tour '%tour%'?",
    success_delete: "Video tour excluído com sucesso",
    layouts_list: "Lista de layouts"
  },
};
